import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MapPin, Clock, Heart } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function IlCuoreDiSciacca() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="il-cuore-di-sciacca" ref={sectionRef} className="dark bg-background text-foreground py-20 lg:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-accent rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className={cn("relative group transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border/10">
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent z-10 !w-[694.667px]" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/image_nlixwsml.webp" alt="Ingresso del laboratorio artigianale Dolci Sapori a Sciacca" className="w-full object-cover transition-transform duration-700 group-hover:scale-105 !h-[800px]" />
              
              {}
              <div className="absolute bottom-6 left-6 z-20 bg-card/90 backdrop-blur-sm border border-border p-4 rounded-xl shadow-lg max-w-[200px]">
                <p className="text-primary font-serif text-lg font-bold italic">
                  "Dove la tradizione incontra la passione."
                </p>
              </div>
            </div>

            {}
            <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-primary/20 rounded-2xl -z-10 hidden lg:block" />
          </div>

          {}
          <div className={cn("space-y-8 transition-all duration-1000 ease-out delay-200 transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12")}>
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-primary font-medium tracking-wider uppercase text-sm">
                <span className="w-8 h-[1px] bg-primary"></span>
                <span>La Nostra Storia</span>
              </div>
              
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-foreground">Una Storia di Tradizione e Passione</h2>
            </div>

            <div className="space-y-6 text-muted-foreground text-lg leading-loose tracking-wide font-sans">
              <p>Dal 1979, Dolci Sapori è molto più di una pasticceria: è un laboratorio di tradizione, dove ogni ricetta racconta una storia siciliana.</p>
              <p>Nata come un piccolo laboratorio familiare, oggi è diventata un punto di riferimento per chi cerca il gusto autentico dei dolci di una volta, realizzati ancora come si faceva un tempo.</p>
              <p>Ogni mattina, mentre Sciacca si sveglia, nel nostro laboratorio il lavoro è già iniziato. L’aria si riempie di profumi familiari e ogni preparazione segue i tempi della vera artigianalità: dolci realizzati in giornata, senza scorciatoie.</p>
              <p>Non produciamo semplicemente dolci. Custodiamo gesti, tradizioni e momenti di vita.</p>
              <p>Dai pranzi della domenica alle grandi occasioni, ogni nostra creazione accompagna emozioni, ricordi e sorrisi, diventando parte delle storie delle famiglie di Sciacca.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-full bg-primary/10 text-primary shrink-0">
                  <Heart className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-serif text-xl font-semibold text-foreground mb-1">Passione Artigianale</h4>
                  <p className="text-sm text-muted-foreground">Ogni dolce è realizzato a mano, con cura per ogni dettaglio e attenzione alla qualità.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-full bg-primary/10 text-primary shrink-0">
                  <MapPin className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-serif text-xl font-semibold text-foreground mb-1">Radici Locali</h4>
                  <p className="text-sm text-muted-foreground">Selezioniamo ingredienti legati al territorio e seguiamo ricette della tradizione siciliana.</p>
                </div>
              </div>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8">
                <Link to="/ContactPage">
                  Vieni a Trovarci
                  <Clock className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}